import React, { Fragment } from 'react'
import {
  Typography,
  Separator,
} from '@klarna/bubble-ui'
import styles from './PaymentMethodDetails.css'
import { isAmountGreaterThanZero } from '../../utilities/amountUtils'

type PaymentMethodDetailsProps = {
  // left
  apr: string
  aprParagraph: string
  aprTranslation: string
  // right
  totalTranslation: string
  installmentsTotal: string
  // center
  downPayment?: string
  downPaymentTranslation?: string
  finalPayment?: string
  finalPaymentTranslation?: string
  interestTranslation?: string
  interestAmount?: string
  interestFreeTranslation?: string
  isInterestGreaterThanZero?: boolean
};

const PaymentMethodDetails: React.FC<PaymentMethodDetailsProps> = ({
  installmentsTotal = '', // FISC
  apr = '0',
  aprParagraph = '0%',
  aprTranslation = '',
  downPayment = '',
  downPaymentTranslation = '',
  finalPayment = '',
  finalPaymentTranslation = '',
  totalTranslation = '',

  interestTranslation = '',
  interestAmount = '',
  interestFreeTranslation = '',
  isInterestGreaterThanZero = false,
}) => (
  <Fragment>
    <style>{styles}</style>
    <Separator />
    <div className="details-container">
      <div className="details-column-container">
        <Typography
          textToken="text-style/text/paragraphs/tiny/regular"
          colorToken="colors/text/neutral-on-background"
          textAlignToken="text-alignment/start">
          {aprTranslation}
        </Typography>
        <Typography
          textToken="text-style/text/paragraphs/tiny/medium"
          colorToken={apr !== '0' && apr !== null ? 'colors/text/default' : 'colors/text/success'} textAlignToken="text-alignment/start"
        >
          {aprParagraph}
        </Typography>
      </div>

      {downPayment ? (
        <div className="details-column-container">
          <Typography
            textToken="text-style/text/paragraphs/tiny/regular"
            colorToken="colors/text/neutral-on-background"
            textAlignToken="text-alignment/start" >
            {downPaymentTranslation}
          </Typography>
          <Typography
            textToken="text-style/text/paragraphs/tiny/medium"
            colorToken="colors/text/default"
            textAlignToken="text-alignment/center" >
            {downPayment}
          </Typography>
        </div>) : null
      }

      { isAmountGreaterThanZero(finalPayment) ? (
        <div className="details-column-container">
          <Typography
            textToken="text-style/text/paragraphs/tiny/regular"
            colorToken="colors/text/neutral-on-background"
            textAlignToken="text-alignment/start" >
            {finalPaymentTranslation}
          </Typography>
          <Typography
            textToken="text-style/text/paragraphs/tiny/medium"
            colorToken="colors/text/default"
            textAlignToken="text-alignment/center" >
            {finalPayment}
          </Typography>
        </div>) : null
      }

      {interestAmount ? (
        <div className="details-column-container">
          <Typography
            textToken="text-style/text/paragraphs/tiny/regular"
            colorToken="colors/text/neutral-on-background"
            textAlignToken="text-alignment/start">
            {interestTranslation}
          </Typography>
          <Typography textToken="text-style/text/paragraphs/tiny/medium"
            colorToken={isInterestGreaterThanZero ? 'colors/text/default' : 'colors/text/success'} textAlignToken="text-alignment/center"
          >
            { isInterestGreaterThanZero ? interestAmount : interestFreeTranslation }
          </Typography>
        </div>) : null
      }

      <div className="details-column-container">
        <Typography
          textToken="text-style/text/paragraphs/tiny/regular"
          colorToken="colors/text/neutral-on-background"
          textAlignToken="text-alignment/end">
          {totalTranslation}
        </Typography>
        <Typography
          textToken="text-style/text/paragraphs/tiny/medium"
          colorToken="colors/text/default"
          textAlignToken="text-alignment/end" >
          {installmentsTotal}
        </Typography>
      </div>
    </div>
  </Fragment>
)

export default PaymentMethodDetails
